module.exports = __webpack_public_path__ + "img/SFA_LOGO.fc0cda7d.png";